import { Colors, Heading, HeadingLevel, Link, Typography, } from '@zapier/design-system';
import { Icon } from '@zapier/design-system';
import { css } from '@emotion/react';
import { isolateComponent } from '@zapier/style-encapsulation';
import { useUniversalNavContext } from '../../../../hooks/useUniversalNavContext';
import { emitUserInteractionEvent } from '../../../../utils/avroEvents';
import { ArrowLinkIcon } from '../../ArrowLinkIcon';
const Styles = {
    root: css({
        display: 'flex',
        flexDirection: 'column',
        gap: 30,
        fontWeight: 'initial',
        minHeight: 373,
    }),
    heading: css(Object.assign(Object.assign({}, Typography.pageHeader9), { display: 'flex', flexDirection: 'column', color: Colors.earth, fontSize: '30px', lineHeight: '24px', letterSpacing: '1px' })),
    subheading: css(Object.assign(Object.assign({}, Typography.smallPrint1), { color: Colors.neutral700, display: 'block', marginTop: 8 })),
    groupsContainer: css({
        display: 'flex',
        gap: '50px',
    }),
    groupHeading: css(Object.assign(Object.assign({}, Typography.sectionHeader3Semibold), { color: Colors.neutral500, fontSize: '14px', letterSpacing: '1px', marginBottom: '10px' })),
    linkList: css({
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
    }),
    linkContainer: css({
        textDecoration: 'none',
        display: 'flex',
        gap: '10px',
        alignItems: 'center',
        '&:hover [data-tag="link-heading"]': {
            color: Colors.zapier,
            textDecoration: 'none',
        },
        '&:hover [data-tag="link-description"]': {
            textDecoration: 'underline',
        },
        '&:hover [data-tag="arrow-icon-wrapper"]': {
            marginLeft: 4,
            opacity: 1,
        },
        '&:focus': {
            outline: `1px solid ${Colors.blue}`,
        },
    }),
    iconContainer: css({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 38,
        height: 38,
        borderRadius: '9px',
        backgroundColor: Colors.cream,
    }),
    linkHeading: css(Object.assign(Object.assign({}, Typography.paragraph3Medium), { height: '26px', lineHeight: '30px', color: Colors.earth })),
    linkDescription: css(Object.assign(Object.assign({}, Typography.smallPrint3), { lineHeight: '20px', color: Colors.neutral700 })),
};
export const MegaMenuProductLeftV2 = ({ heading, onCloseMenu, subheading, submenu, }) => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const handleEvent = (text, eventType) => {
        emitUserInteractionEvent({
            event_action: eventType,
            option_selected: `Product tab Left: ${text}`,
        });
        if (eventType === 'click' && onCloseMenu)
            onCloseMenu();
    };
    return (isolateComponent("div", { css: Styles.root },
        isolateComponent("header", null,
            isolateComponent(HeadingLevel, null,
                isolateComponent(Heading, { css: Styles.heading }, heading)),
            isolateComponent("span", { css: Styles.subheading }, subheading)),
        isolateComponent("div", { css: Styles.groupsContainer }, submenu.map((group) => {
            var _a;
            return (isolateComponent("div", { key: group.text },
                isolateComponent(HeadingLevel, null,
                    isolateComponent(Heading, { css: Styles.groupHeading }, group.text)),
                isolateComponent("ul", { css: Styles.linkList }, (_a = group.submenu) === null || _a === void 0 ? void 0 : _a.map((link) => (isolateComponent("li", { key: link.text },
                    isolateComponent(Link, { color: null, css: Styles.linkContainer, href: getFullyQualifiedURL(link.href), target: link.target, onClick: () => handleEvent(link.text, 'click'), onMouseEnter: () => handleEvent(link.text, 'hover') },
                        link.icon && (isolateComponent("div", { css: Styles.iconContainer },
                            isolateComponent(Icon, { color: "brand", name: link.icon, size: 19 }))),
                        isolateComponent("div", { css: {
                                display: 'flex',
                                flexDirection: 'column',
                            } },
                            isolateComponent("span", { css: Styles.linkHeading, "data-tag": "link-heading" }, link.text),
                            isolateComponent("span", { css: Styles.linkDescription, "data-tag": "link-description" },
                                link.description,
                                isolateComponent(ArrowLinkIcon, null))))))))));
        }))));
};
//# sourceMappingURL=MegaMenuProductLeftV2.js.map
// @zapier/universal-layout@8.11.3 (3d6dc537c)
